export enum PreferredCommunicationMethod {
    Email = 0,
    Sms = 1,
}
